var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('army-mound'),_vm._v(" "),(_vm.atWar)?_c('war'):_c('nations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }